import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import Button from "@material-ui/core/Button";
import { carBrands } from "../../AppConstants";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SimpleModal from "../Common/Utilities/SimpleModal";
import PhoneIcon from "@material-ui/icons/Phone";
import MailIcon from "@material-ui/icons/Mail";

export default function HomePage(props) {
  const history = useHistory();
  const [loader, setLoaderVisibility] = useState(true);
  const [brands, setBrands] = useState([]);
  const isMobile = useMediaQuery("(max-width:769px)");

  useEffect(() => {
    setBrands(props.brands);
    if (props.brands.length > 0) {
      setLoaderVisibility(false);
    }
  }, [props.brands]);

  return (
    <React.Fragment>
      <div className="white">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            style={{ maxWidth: "320px", paddingTop: "35px" }}
            onClick={() => history.push("/")}
            className="metropool"
            alt="Metropool"
            src="/assets/img/headerimage.png"
          />
        </div>
        <div>
          <div className="row">
            {brands.length > 0 && (
              <div className="col-lg-12 col-md-12 col-sm-12">
                <CSSTransition
                  in={!loader}
                  timeout={900}
                  classNames="list-transition"
                  appear
                  unmountOnExit
                >
                  <div style={{ height: "75dvh" }} key={props.brand} className="row">
                    {brands.map((item) => (
                      <React.Fragment key={item.name}>
                        <div style={{ position: "relative" }} className="col-lg-6 col-md-6 col-sm-12">
                          <div
                            style={{
                              height: isMobile ? "200px" : "230px",
                              zIndex: "2",
                            }}
                            className="logo-container"
                          >
                            <div
                              style={{
                                height: isMobile ? "100px" : "150px",
                                zIndex: "2",
                              }}
                              className="logo-container-image"
                            >
                              <img alt={item.name} src={item.image} />
                            </div>
                            <Button
                              className={`${item.name.split(" ").join("").toLowerCase()}-button`}
                              onClick={() => {
                                props.reactGA.event({
                                  category: "Brand",
                                  action: "Select",
                                  label: item.name.toLowerCase(),
                                });
                                history.push(`/${item.permalink.toLowerCase()}`);
                              }}
                              style={{
                                fontFamily: item.name === carBrands.jaguar.title ? "Jaguar" : "LandRover",
                                cursor: "pointer",
                                zIndex: "2",
                              }}
                            >
                              Maak afspraak
                            </Button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </CSSTransition>
                <footer className="footerContainer" style={{ backgroundColor: "#333" }}>
                  <div style={{ paddingTop: "50px" }} className="container">
                    <div className="row">
                      <div className="col-lg-4 col-sm-12" style={{ marginBottom: "55px" }}>
                        <p>Jaguar Land Rover Kempen</p>
                        <p>Herenthoutseweg 235 ,2200 Herentals</p>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <PhoneIcon style={{ marginRight: "10px" }} />
                          <a href="tel:+3214211373">+ 32(0)1 421 13 73</a>
                        </div>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <MailIcon style={{ marginRight: "10px" }} />
                          <a href="mailto:info@metropool-kempen.be">info@metropool-kempen.be</a>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-12" style={{ marginBottom: "55px" }}>
                        <p>Jaguar Land Rover Metropool Noord</p>
                        <p>Bredabaan 1165-1171,2900 Schoten</p>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <PhoneIcon style={{ marginRight: "10px" }} />
                          <a href="tel:+3236416590">+ 32(0)3 641 65 90</a>
                        </div>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <MailIcon style={{ marginRight: "10px" }} />
                          <a href="mailto:info@metropool-noord.be">info@metropool-noord.be</a>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-12" style={{ marginBottom: "55px" }}>
                        <p>Jaguar Land Rover Metropool Zuid</p>
                        <p>Boomsesteenweg 427,2610 Wilrijk</p>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <PhoneIcon style={{ marginRight: "10px" }} />
                          <a href="tel:+3236083131">+ 32(0)3 608 31 31</a>
                        </div>
                        <div style={{ marginTop: "10px" }} className="flex">
                          <MailIcon style={{ marginRight: "10px" }} />
                          <a href="mailto:info@metropool-zuid.be">info@metropool-zuid.be</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            )}
          </div>
        </div>
      </div>
      {props.showHomePageText === "true" && props.homePageText != null && (
        <SimpleModal text={props.homePageText} showModal={true} />
      )}
    </React.Fragment>
  );
}
